import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        step: '='
    },
    template: `
        <div class="arrow-steps clearfix">
            <div class="step" ng-class="{ current: vm.step==1 }">
                <span ng-if="vm.step <= 1">{{ 'question.Upload file' | translate }}</span>
                <a ng-click="vm.step = 1" ng-if="vm.step > 1">{{ 'question.Upload file' | translate }}</a>
            </div>
            <div class="step" ng-class="{ current: vm.step === 2 }">
                <span>{{ 'question.Organize data' | translate }}</span>
            </div>
            <div class="step" ng-class="{ current: vm.step === 3 }">
                <span>{{ 'question.Correct errors' | translate }}</span>
            </div>
            <div class="step" ng-class="{ current: vm.step === 4 }">
                <span ng-if="vm.step <= 4">{{ 'question.Summary' | translate }}</span>
                <a ng-click="vm.step = 4" ng-if="vm.step > 4">{{ 'question.Summary' | translate }}</a>
            </div>
        </div>
    `
})
export default class {
}



// WEBPACK FOOTER //
// ./src/app/components/modals/question/import/steps/index.js